/* 
 * 接口统一集成模块
 */
import * as login from './moudules/login'
import * as pf from './moudules/pf'
import * as bs from './moudules/bs'
import * as allApi from './moudules/allApi'

// 默认全部导出
export default {
    login,
    pf,
    bs,
    allApi
}


// WEBPACK FOOTER //
// ./src/http/api.js